import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuditPfacComponent } from 'src/app/configuration-pfac/components/audit-pfac/audit-pfac.component';
import { ReleaseOfUnwantedCnaeAuditModel } from '../../models/releaseOfUnwantedCnae.models';

@Component({
  selector: 'app-audit-release-of-unwanted-cnae',
  standalone: false,
  templateUrl: './audit-release-of-unwanted-cnae.component.html',
  styleUrl: './audit-release-of-unwanted-cnae.component.scss'
})
export class AuditReleaseOfUnwantedCnaeComponent implements OnInit {

  audits: ReleaseOfUnwantedCnaeAuditModel[] = [];
  hasValue = false;
  displayedColumns = ['cnpj', 'clientName', 'cnae', 'period', 'doneBy', 'action', 'actionDateTime'];

  constructor(@Inject(MAT_DIALOG_DATA) public data: ReleaseOfUnwantedCnaeAuditModel[],
            public dialogRef: MatDialogRef<AuditPfacComponent>,) {}

  ngOnInit(): void {
    this.audits = this.data || [];
    this.hasValue = this.audits.length > 0;
  }

  getDoneBy(audit: ReleaseOfUnwantedCnaeAuditModel): string {
    return audit.nameUser || audit.documentUser || '-';
  }

  getActionLabel(action: string): string {
    if (action === 'Created') {
      return 'Inclusão';
    }
    if (action === 'Updated') {
      return 'Edição';
    }
    if (action === 'Disabled') {
      return 'Desabilitação';
    }
    if (action === 'Activated') {
      return 'Habilitação';
    }

    return action;
  }

  close(): void {
    this.dialogRef.close();
  }
}
